import { defineComponent as _defineComponent } from 'vue'
import { IUserInfo } from "@/domain/entities/user";
import { useServiceStore } from "@/stores/serviceStore";

import { computed, PropType, ref, watch } from "vue";


const __default__ = {
  name: "WelcomeMessages",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  userInfo: {
    type: Object as PropType<IUserInfo>,
    required: true,
  },
},
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props;

const serviceStore = useServiceStore();

// 웰컴 메시지 적용
const serviceInfoWelcomeMessages = computed(() => serviceStore.welcomeMessages);

const loginHtml = computed(() => {
  return serviceStore.serviceInfo?.campaigns?.find(
    (campaign) => campaign.loginHtml?.length
  )?.loginHtml;
});

const userNickName = computed(() => `${props.userInfo?.alias ?? "구성원"}님,`);

const defaultMessages = computed(() => [userNickName.value, "반갑습니다!"]);
const welcomeMessages = ref(["구성원님", "반갑습니다!"]);

const updateWelcomeMessages = () => {
  welcomeMessages.value = getWelcomeMessages();
};

const getWelcomeMessages = () => {
  if (loginHtml.value) {
    return [loginHtml.value];
  }

  const [basic] = serviceInfoWelcomeMessages.value.map((messages) =>
    messages.map((token) => token.replace("$memberAlias,", userNickName.value))
  );

  const fallbackMessages = basic ?? defaultMessages.value;

  // @REMOVE : 기획 변경 - '시간대별 웰컴텍스트 표시'에서 '항상 같은 텍스트 표시'
  // const now = dayjs();
  // const hour = now.hour(); // 0~23 시간 반환

  // if (hour >= 6 && hour < 12) {
  //   return morning ?? fallbackMessages;
  // }

  // if (hour >= 12 && hour < 17) {
  //   return afternoon ?? fallbackMessages;
  // }

  return fallbackMessages;
};

// const intervalWelcomeMessages = ref();
// const setIntervalWelcomeMessages = () => {
//   // if (!currentFavoriteLine.value) return;
//   updateWelcomeMessages();
//   // 1분 간격 업데이트
//   intervalWelcomeMessages.value = setInterval(updateWelcomeMessages, 60000);
// };

// const removeIntervalWelcomeMessages = () => {
//   clearInterval(intervalWelcomeMessages.value);
// };

watch(
  () => userNickName.value,
  () => {
    updateWelcomeMessages();
  },
  { immediate: true }
);

const __returned__ = { props, serviceStore, serviceInfoWelcomeMessages, loginHtml, userNickName, defaultMessages, welcomeMessages, updateWelcomeMessages, getWelcomeMessages }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})